import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCalenderAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"calender-add, date-add"} maskId="square-filled-radius-0-stroke-1-IconCalenderAdd"><path d="M8 2H7V4H3V21H13V20H4V9H20V13H21V4H17V2H16V4H8V2Z" fill="currentColor"/><path d="M19 15H18V18H15V19H18V22H19V19H22V18H19V15Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCalenderAdd;
